import { t as a } from "./names-CFkjAQeT.js";
function n(o) {
  return o !== null && typeof o == "object" && !Array.isArray(o) ? o : void 0;
}
function A(o) {
  const s = n(n(o)?.[a]);
  if (!s) return;
  const t = [];
  if (s.sources === void 0) return { problems: t };
  if (!Array.isArray(s.sources))
    return t.push("`sources` is not an array"), { problems: t };
  const i = [];
  return s.sources.forEach((c, u) => {
    const r = n(c), e = r?.externalAsset;
    if (!r || !Number.isInteger(e) || e < 0) {
      t.push(`sources[${u}] has no valid externalAsset`);
      return;
    }
    if (r.root !== void 0 && (typeof r.root != "string" || r.root === "")) {
      t.push(`sources[${u}].root ${JSON.stringify(r.root)} is not a node name`);
      return;
    }
    i.push({
      externalAsset: e,
      ...r.root !== void 0 ? { root: r.root } : {}
    });
  }), {
    sources: i,
    problems: t
  };
}
export {
  A as t
};

//# sourceMappingURL=schema-9wLyxyBJ.js.map